var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tagTemp_wapper",staticStyle:{"margin-bottom":"20px"}},[_c('canvas',{staticClass:"exportCanvas",attrs:{"id":_vm.plankIndex + 'printTag' + _vm.index,"labelName":_vm.currentPlank ? _vm.currentPlank.lableImgName : 1}})])
}
var staticRenderFns = []

export { render, staticRenderFns }